interface BackofficePageProps {

}

export const BackofficePage: React.FC<BackofficePageProps> = () => {
    return <section className="backoffice-page page-content-padding">
    </section>
}
